<template>
  <div class="wrap talk" style="background-color: white;">
    <div class="container">
      <main class="content">
        <section class="coupon-container">
            <div class="top-box">
                <img src="@/assets/images/img-coupon.png" alt="" width="144">
                <p>안내 받으신 <b>민팃 쿠폰은 아래와 같이 사용</b>하시면 됩니다.</p>
            </div>
            <div class="bot-box">
                <dl>
                    <dt>
                        <span>STEP 1</span>
                        <p><b>쿠폰받기</b></p>
                    </dt>
                    <dd>
                        <div class="text-box">
                            <p>민팃이나 민팃과 제휴하고 있는 협력사들 통해서 알림톡, 문자, 이벤트 페이지, 메일 등 다양한 경로를 통해 쿠폰을 받거나 확인하시면 됩니다.</p>
                        </div>
                        <div class="img-box">
                            <img src="@/assets/images/img-coupon-list01.png" alt="" width="100%">
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        <span>STEP 2</span>
                        <p>민팃ATM에 <b>중고폰 판매하기</b></p>
                    </dt>
                    <dd>
                        <div class="text-box">
                            <p>전국에 설치된 약 6,800대 민팃ATM에 중고폰을 판매하시면 됩니다. 단, <b>특정 기종이나 등급 등 조건이 있는 쿠폰은 해당 조건에 맞는 중고폰을 판매하셔야 쿠폰 사용이 가능</b>할 수 있습니다.</p>
                        </div>
                        <div class="img-box">
                            <img src="@/assets/images/img-coupon-list02.png" alt="" width="100%">
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        <span>STEP 3</span>
                        <p>계좌 입력 시 <b>쿠폰번호 입력하기</b></p>
                    </dt>
                    <dd>
                        <div class="text-box">
                            <p>중고폰 판매완료 후 판매금액 입금을 위한 계좌 입력 알림톡이발송되고 계좌입력 화면 하단에 쿠폰번호 입력 창에 해당 쿠폰 번호를 입력하시면 됩니다. 단, <b>판매 건당 1개의 쿠폰번호만을 입력</b>할 수 있습니다.</p>
                        </div>
                        <div class="img-box">
                            <img src="@/assets/images/img-coupon-list03.png" alt="" width="100%">
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        <span>STEP 4</span>
                        <p><b>쿠폰 혜택 받기</b></p>
                    </dt>
                    <dd>
                        <div class="text-box">
                            <p>안내 받으신 쿠폰의 혜택 지급 시점에, 혜택이 지급됩니다. <br/>단, <b>현금 지급 혜택은 중고폰 판매 시 입력한 계좌로 입금</b>됩니다.</p>
                        </div>
                    </dd>
                </dl>
            </div>
            <div class="notice-accordion-section">
                <div class="notice-title">
                    <img src="@/assets/images/icon-notice-arrow.svg" alt="">
                    <p>꼭 확인하세요.</p>
                </div>
                <div class="notice-desc">
                    <p>이벤트 유의사항</p>
                    <ul>
                        <li>1만원 이상의 중고폰을 판매한 민팃 이용고객만 대상입니다.</li>
                        <li>본 이벤트는 민팃 커넥터 설치가 불가한 기기는 대상에서 제외됩니다. <br/>(※ 민팃 커넥터란? 휴대기기 성능진단과 데이터 삭제를 위한 프로그램으로 중고폰 판매 전 설치 필수)</li>
                        <li>추가 1만원은 판매 시 입력한 계좌번호로 입금됩니다.</li>
                        <li>본 이벤트의 혜택은 타 이벤트와 중복으로 지급받을 수 없습니다.</li>
                        <li>본 이벤트는 내부 사정에 의해 사전 고지 없이 변경 또는 종료될 수 있습니다.</li>
                    </ul>
                </div>
            </div>
        </section>
        <!-- <div class="cs-center row row_ac row_jsc b-cs">
          <a
            href="tel: 1877-2660"
            class="en phone"
            style="padding-left:3px;"
            >
              <span class="qa" style="font-size:1.1rem;">
                고객센터 문의 :
                <span>
                1877-2660
              </span>
            </span>
          </a>
        </div> -->
      </main>
    </div>
  </div>
</template>

<script>
import utils from '@/modules/utils'

export default {
  name: 'CouponGuide',
  components: {
  },
  data: () => ({
  }),
  computed: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style>
    .coupon-container{
        font-family:"SUIT", sans-serif;
        max-width:1024px;
        width:100%;
        margin:0 auto;
        padding:80px 24px 60px;
        box-sizing: border-box;
    }
    .coupon-container .top-box{
        display:flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap:32px;
        text-align: center;
    }
    .coupon-container .top-box p{
        color: #333;
        font-size: 14px;
        font-weight: 800;
        line-height: 18px; 
    }
    .coupon-container .top-box p b{
        background:#D0F7EF;
    }
    .coupon-container .bot-box{
        padding:40px 0 60px;
        display:flex;
        flex-direction: column;
        gap:40px;
    }
    .coupon-container .bot-box dl{
        display:flex;
        flex-direction: column;
        gap:16px;
        width:100%;
    }
    .coupon-container .bot-box dl dt{
        display:flex;
        gap:10px;
        align-items: center;
    }
    .coupon-container .bot-box dl dt span{
        color: #3FDBBF;
        font-size: 11px;
        font-weight: 800;
        line-height: 14px;
    }
    .coupon-container .bot-box dl dt p{
        flex:1;
        color:  #333;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px; 
    }
    .coupon-container .bot-box dl dt p b{
        font-weight: 800;
    }
    .coupon-container .bot-box dl dd{
        display:flex;
        flex-direction: column;
        gap:16px;
        width:100%;
    }
    .coupon-container .bot-box dl dd .text-box p{
        color:#8B8B8B;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        word-break: break-all;
    }
    .coupon-container .bot-box dl dd .text-box p b{
        font-weight: 800;
        text-decoration-line: underline;
    }
    .coupon-container .notice-accordion-section {
        display:flex;
        flex-direction: column;
        gap:24px;
    }
    .coupon-container .notice-accordion-section .notice-title{
        display:flex;
        gap:8px;
        align-items: center;
    }
    .coupon-container .notice-accordion-section .notice-title p{
        color: #141414;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
    }
    .coupon-container .notice-accordion-section .notice-desc{
        display:flex;
        flex-direction: column;
        gap:12px;
    }
    .coupon-container .notice-accordion-section .notice-desc p{
        color: #262626;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        padding-bottom:8px;
        border-bottom:1px solid #E5E5E5;
    }
    .coupon-container .notice-accordion-section .notice-desc ul{
        width: 100%;
        display:flex;
        flex-direction: column;
    }
    .coupon-container .notice-accordion-section .notice-desc ul li{
        position:relative;
        padding-left:12px;
        color: #666;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
    }
    .coupon-container .notice-accordion-section .notice-desc ul li::before{
        content: 'ㆍ';
        position:absolute;
        left:0;
    }
</style>



// WEBPACK FOOTER //
// src/views/purchase/CouponGuide.vue